import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, del, post } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../UpStream/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../UpStream/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import AddPartner from "../UpStream/AddPartner";
import ViewUpStream from "../UpStream/ViewPartner";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../../Layout/MainSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const DownStream = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Industry: false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Industry: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    Industry: [],
  });
  const filters = ["Date", "Industry"];
  const [searchQuery, setSearchQuery] = useState("");

  const inputData = [
    {
      fieldName: "partner",
    },

    {
      fieldName: "industry",
      title: " Industry",
      placeholder: "Tap to Select",
      type: "select",
    },
    // {
    //   fieldName: "partnershipType",
    //   title: " Partnership Type",
    //   placeholder: "Tap to Select",
    //   type: "select",
    // },

    {
      fieldName: "address",
      title: "Address",
      placeholder: "Enter Address",
    },
    {
      fieldName: "country",
      title: "Country",
      placeholder: "Tap to Select",
      type: "select",
    },
    {
      fieldName: "contactPersonName",
      title: "Contact Person Name",
      placeholder: "Enter Contact Person Name",
    },
    {
      fieldName: "contactNumber",
      title: "Contact Number",
      placeholder: "Enter Mobile No ",
    },
    {
      fieldName: "email",
      title: "Email ID",
      placeholder: "Enter Email",
    },
    {
      fieldName: "materialsOrServices",
      title: "Materials / Services involved in business ",
      placeholder: "Materials / Services",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const queryParams = new URLSearchParams({
        direction: "Downstream",
      }).toString();
      const response = await get(`/valueChain/partner/get?${queryParams}`);
      const data = response.data.data;

      const uniqueIndustries = [
        ...new Set(
          data.map((el) => el.industry).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        industry: uniqueIndustries,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    console.log(filters);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        direction: "Downstream",
        search: searchQuery,
      }).toString();
      const response = await get(`/valueChain/partner/get?${queryParams}`);

      setData(response.data.data);
      console.log("list", response.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig, searchQuery]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
    console.log(element);
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };
  const handleRequestData = async (id) => {
    try {
      handleMenuClose();
      const response = await post(`${api}/valueChain/request/requestData`, {
        _id: id,
      });

      setsnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
      fetchData();
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAggree = async () => {
    // console.log("indexhandleDeleteAggree", vehicle, vehicle._id);
    try {
      console.log(element._id);
      const res = await del(`${api}/valueChain/partner/get/${element._id}`);
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
    } catch (err) {
      console.log(err);
      setsnackOpen({
        open: true,
        message: err.data?.response.message ?? "network Error",
        severity: "error",
      });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    // company: companyId,
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    industry:
      selectedFields?.Industry?.length > 0
        ? selectedFields.Industry.join(",")
        : "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      Industry: false,
    };

    console.log(selectedFilter, "hi");

    if (selectedFilter === "Date") {
      const today = new Date();
      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    // if (!validateFilters()) return;

    setPage(1);
    console.log(selectedFields, filtersToApply, "try1");
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      Industry: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = startDate || endDate ? true : false;
    const isIndustryApplied =
      selectedFields.Industry?.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isIndustryApplied);

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Industry: isIndustryApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setDrawerFilterOpen(false);
    if (!appliedFilters?.Date) {
      setStartDate(null);
      setEndDate(null);
    }
    if (!appliedFilters?.Industry) setSelectedFields({ Industry: [] });
    setErrors({ Date: false, Country: false });
  };

  const columnHeadings = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "partnerCompany",
      title: "Value Chain Partner",
    },
    {
      fieldName: "industry",
      title: "Industry",
    },
    {
      fieldName: "contactPersonName",
      title: "Contact Person",
    },
    {
      fieldName: "contactNumber",
      title: "Mobile",
    },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/valueChain/partner/get`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
      case "Industry":
        return (
          <MultiSelect
            title="Industry"
            url={`${api}/valueChain/partner/get`}
            selectedField={selectedFields.Industry}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            errors={errors.Industry}
            setErrors={setErrors}
            field="Industry"
            data={uniqueValues.industry}
          />
        );

      default:
        return (
          <DateRangePickerComponent
            url={`${api}/valueChain/partner/get`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
    }
  };

  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="Value Chain | Partner">
        <Box
          sx={{
            // padding: "20px",
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />

          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddPartner
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            element={element}
            addUrl={`${api}/valueChain/partner/add`}
            updateUrl={`${api}/valueChain/partner/update`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
            direction="Downstream"
          />

          <ViewUpStream
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            {...{
              heading: "Value Chain",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {deleteDialog && (
            <DeleteDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                handleDeleteAggree,
                setsnackOpen,
                id: element?._id,
                url: `/valueChain/partner/delete`,
                fetchData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}

          <TableContainer
            component={Paper}
            sx={{ maxWidth: "100%" }}
            ref={tableContainerRef}
          >
            <Box>
              <TableHeading heading={"Value Chain Partners"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el.fieldName}
                    {...{
                      title: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => {
                      const fieldData = item[el.fieldName];

                      // Handle special case for partnerCompany to extract the 'name' field
                      let displayValue;
                      // if (el.fieldName === "partnerCompany" && fieldData) {
                      //   displayValue = fieldData.name; // Display the partner's name
                      if (el.fieldName === "partnerCompany") {
                        displayValue =
                          fieldData?.companyName || item.newPartnerName;
                      } else if (
                        el.fieldName === "contactNumber" &&
                        fieldData
                      ) {
                        const countryCode = fieldData.countryCode?.startsWith(
                          "+"
                        )
                          ? fieldData.countryCode
                          : `+${fieldData.countryCode}`;
                        displayValue = `${countryCode} ${fieldData.mobileNo}`;
                      } else if (
                        typeof fieldData === "object" &&
                        fieldData !== null
                      ) {
                        displayValue = JSON.stringify(fieldData);
                      } else {
                        displayValue = fieldData;
                      }

                      return (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData: displayValue,
                            dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                          }}
                        />
                      );
                    })}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
              partnerType: selectedData?.partner,
              sendForApproval: selectedData?.sendForApproval,
              handleRequestData: () => handleRequestData(element?._id),
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default DownStream;
